module.exports = "https://www.gc-pro.gnp.com.mx/755b7fea36d7dc38516baa647511c05c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menu-icon-mobile.svg
// module id = 8152
// module chunks = 0